import { create } from 'zustand';
import { findBestLocaleFromString } from '../utils/locale';

export type AppLocale = {
  locale: string;
  localeId: number;
};

export const EN = { locale: 'en', localeId: 1033 };
export const TH = { locale: 'th', localeId: 1054 };

export type LocaleState = {
  appLocale: AppLocale;
  locale: string;
  localeId: number;
};

export type LocaleActions = {
  setAppLocale: (locale: AppLocale | string) => void;
};

export type LocaleStore = LocaleState & LocaleActions;

export const useLocaleStore = create<LocaleStore>((set) => ({
  appLocale: EN,
  locale: 'en',
  localeId: 1033,

  setAppLocale: (locale: AppLocale | string) => {
    const newLocale = typeof locale === 'string' ? findBestLocaleFromString(locale) : locale;
    set({
      appLocale: newLocale,
      locale: newLocale.locale,
      localeId: newLocale.localeId,
    });
  },
}));
